import HomePageServices from './HomePageServices';
import HomePageServicesMock from './HomePageServicesMock';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? HomePageServicesMock : HomePageServices;
